<div data-cy="openlayers-sidebar-v2__page"
  id="sidebar"
  [ngClass]="collapse ? 'collapsed' : ''"
  class="{{ 'sidebar sidebar-' + randomId }}"
>
  <!-- Nav tabs -->
  <div class="sidebar-tabs" *ngIf="type != 'activities'&&type!=='context'">
    <ul role="tablist">
      <li [ngClass]="{ active: showContent }" *ngIf="buttons.includes('layer')">
        <a data-cy="openlayers-sidebar-v2__link"
          (click)="!contextPanel && setSelectedTool('layer')"
          [class]="
            purposeTool === 'layer'
              ? 'ol-control-active d-cursor-hand'
              : 'd-cursor-hand'
          "
          href="#layers"
          role="tab"
        >
          <mat-icon>layers</mat-icon>
        </a>
      </li>
      <li
        *ngIf="
          buttons.includes('draw') &&
          !contextPanel &&
          (hasPermission(Permission.StakeholdersCreate) ||
            hasPermission(Permission.IssuesCreate) ||
            hasPermission(Permission.ComplaintsCreate) ||
            hasPermission(Permission.ActionCreate) ||
            hasPermission(Permission.DecisionsCreate))
        "
      >
        <a data-cy="openlayers-sidebar-v2__set-selected-tool"
          (click)="setSelectedTool('draw')"
          [class]="
            purposeTool === 'draw'
              ? 'ol-control-active d-cursor-hand'
              : 'd-cursor-hand'
          "
          href="#draw"
          role="tab"
        >
          <mat-icon class="uil uil-plus-circle"></mat-icon>
        </a>
      </li>
      <li
        [ngClass]="purposeTool === 'point' ? 'active' : ''"
        *ngIf="buttons.includes('point')"
      >
        <a data-cy="openlayers-sidebar-v2__set-selected-tool-2"
          (click)="setSelectedTool('point')"
          [class]="
            purposeTool === 'point'
              ? 'ol-control-active d-cursor-hand'
              : 'd-cursor-hand'
          "
        >
          <mat-icon>adjust</mat-icon>
        </a>
      </li>
      <li
        [ngClass]="purposeTool === 'length' ? 'active' : ''"
        *ngIf="buttons.includes('length')"
      >
        <a data-cy="openlayers-sidebar-v2__set-selected-tool-3"
          (click)="setSelectedTool('length')"
          [class]="
            purposeTool === 'length'
              ? 'ol-control-active d-cursor-hand'
              : 'd-cursor-hand'
          "
        >
          <mat-icon>gesture</mat-icon>
        </a>
      </li>
      <li *ngIf="buttons.includes('area')">
        <a data-cy="openlayers-sidebar-v2__set-selected-tool-4"
          (click)="setSelectedTool('area')"
          [class]="
            purposeTool === 'area'
              ? 'ol-control-active d-cursor-hand'
              : 'd-cursor-hand'
          "
        >
          <mat-icon>crop_landscape</mat-icon>
        </a>
      </li>
      <li *ngIf="buttons.includes('add-stakeholder')">
        <a data-cy="openlayers-sidebar-v2__set-selected-tool-5"
          (click)="setSelectedTool('add-stakeholder')"
          [class]="
            purposeTool === 'add-stakeholder'
              ? 'ol-control-active d-cursor-hand'
              : 'd-cursor-hand'
          "
        >
          <mat-icon>person_add</mat-icon>
        </a>
      </li>
    </ul>
  </div>
  <mat-button-toggle-group data-cy="openlayers-sidebar-v2__toggler-activites"
    class="polygon-edit-toggle"
    *ngIf="type == 'activities'||type == 'context'"
    [(ngModel)]="togglerActivites"
  >
    <mat-button-toggle value="point" (click)="setSelectedTool('point')">
      <mat-icon class="mat-icon-height-set">adjust</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="length" (click)="setSelectedTool('length')">
      <mat-icon class="mat-icon-height-set">gesture</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="area" *ngIf="type==='context'" (click)="setSelectedTool('area')">
      <mat-icon class="mat-icon-height-set">crop_landscape</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
  <!-- Tab pane Layers -->
  <div class="sidebar-content" *transloco="let t" [style.height]="(contextPanel || contextGraph) && '75vh !important'" [style.width]="contextGraph&&'346px !important'">
    <div class="sidebar-pane active" *ngIf="showLayers">
      <h1 class="sidebar-header" (click)="sidebarClose()">
        <span class="sidebar-close" *ngIf="!contextGraph" #closeLayer><<</span>
      </h1>
      <!-- Search  -->
      <h3 style="margin-bottom: 3px; margin-top: 3px; margin-left: 3px;" *ngIf="!contextPanel && !contextGraph">{{'maps.search_address' | transloco}}</h3>
      <div class="map-search mb-5 mt-2" *ngIf="!contextPanel && !contextGraph">
        <input data-cy="openlayers-sidebar-v2__keyword-input"
          type="text"
          [(ngModel)]="_mapServices.keyword"
          class="form-control universal-search map-overall-search ng-pristine ng-valid ng-touched search-address"
          placeholder="{{'maps.search_address' | transloco}}"
          (input)="search($event.target.value)"
        />
        <div class="ng-star-inserted">
          <i *ngIf="loadingSearch" class="uil uil-spinner-alt uil-icon spinner-animation form-control-map-spinner"></i>
            <!-- <i  class="uil uil-search uil-icon"></i> -->
          <span *ngIf="!loadingSearch" class="uil uil-search form-control-map-search"></span>
        </div>
        <!-- Display Search Results -->
        <div *ngIf="showResultsContainer"  class="search-results-container">
          <ul style="padding: 5px;">
            <ng-container *ngIf="searchResults.length > 0; else notFound">
              <li
                *ngFor="let result of searchResults; let i = index"
                [class]="'search-result-item-'+i"
                [class.selected]="i === selectedResultIndex"
                (click)="panToLocation(result); onItemClick(i)"
              >
                {{ result.display_name }}
              </li>
            </ng-container>
            <ng-template #notFound>
              <li class="not-found-message">Not found</li>
            </ng-template>
          </ul>
        </div>
      </div>

      <!-- Context layers  -->
      <mat-card data-cy="openlayers-sidebar-v2__card" class="p-10 mb-10" *ngIf="contextPanel || contextGraph">
        <h3 class="layers-header-title">{{'Context'}}</h3>
        <mat-accordion>
          <app-item-layers-accordion
            [type]="[
              'physical',
              'regulatory',
              'political',
              'social',
              'emotional'
            ]"
            [showToggles]="showToggles"
            [contextGraph]="contextGraph"
            [contextPanel]="contextPanel"
            (toggleChangeItem)="toggleitemsLayers($event)"
          ></app-item-layers-accordion>
        </mat-accordion>
      </mat-card>
      <!-- Context items  -->
      <mat-card data-cy="openlayers-sidebar-v2__card-2" class="p-10 mb-10" *ngIf="contextGraph && globals.aiAnalysisModuleEnabled">
        <h3 class="layers-header-title">{{'Items'}}</h3>
        <mat-accordion>
          <app-item-layers-accordion
            [type]="['ctx_stakeholders', 'ctx_issues', 'contactpersons',  'ctx_requirements', 'contactmoments', 'permits', 'contents', 'ctx_activities', 'ctx_complaints']"
            [showToggles]="showToggles"
            [contextGraph]="contextGraph"
            (toggleChangeItem)="toggleitemsLayers($event)"
          ></app-item-layers-accordion>
        </mat-accordion>
      </mat-card>
      <!-- items layers  -->
      <mat-card data-cy="openlayers-sidebar-v2__card-3" class="p-10 mb-10" *ngIf="!contextGraph">
        <h3 class="layers-header-title">Items</h3>
        <mat-accordion>
          <app-item-layers-accordion
            [type]="contextPanel ? [
              'stakeholder',
              'issue',
              'requirements'
            ]:[
              'stakeholder',
              'issue',
              'complaints',
              'requirements',
              'activity'
            ]"
            [showToggles]="showToggles"
            (toggleChangeItem)="toggleitemsLayers($event)"
          ></app-item-layers-accordion>
        </mat-accordion>
      </mat-card>
      <!-- subproject Layers  -->
      <mat-card data-cy="openlayers-sidebar-v2__card-4"
        class="p-10 mb-10"
        *ngIf="hasModule('subprojects') && hasStandingLevel(router) && !contextGraph"
      >
        <h3 class="layers-header-title">
          {{
            this.globals.projectConfigs["project.labels.subprojects"] ||
              "subprojects.label" | transloco
          }}
        </h3>
        <mat-accordion>
          <app-feature-layers-accordion
            (toggleOpenDataLayers)="toggleOpenDataLayers($event)"
            (onChangeLayerStyle)="onChangeStyle($event)"
            [layers]="layers['subproject']"
            [showToggles]="showToggles"
            [showSubLayer]="true"
          ></app-feature-layers-accordion>
        </mat-accordion>
      </mat-card>
      <!-- External Projects -->
      <mat-card data-cy="openlayers-sidebar-v2__card-5"
        class="p-10 mb-10"
        *ngIf="!contextGraph && !contextPanel && hasRole('Project Admin') && hasModule('share') && !isSharedSubproject()"
      >

        <div class="d-flex j-space-between">
          <h3 class="a-self-center layers-header-title">{{ "maps.external_projects" | transloco }}</h3>
        </div>
        <div class="map-search mb-5 mt-2" *ngIf="!is_loadAllProjects">
          <input
            data-cy="openlayers-sidebar-v2__external-project-search"
            type="text"
            [(ngModel)]="externalProjectSearch"
            class="form-control universal-search map-overall-search ng-pristine ng-valid ng-touched search-address"
            placeholder="{{ 'maps.search_project' | transloco }}"
            (input)="onExternalProjectSearch($event.target.value)"
          />
          <span class="uil uil-search form-control-map-search"></span>
        </div>
        <div
          *ngIf="is_loadAllProjects"
          class="w-100 load-openlayers d-flex j-space-center"
        >
          <mat-spinner></mat-spinner>
        </div>
        <div *ngIf="!is_loadAllProjects">
          <mat-accordion *ngIf="hasModule('external_share')">
            <app-feature-layers-accordion
              (toggleOpenDataLayers)="toggleOpenDataLayers($event)"
              (onChangeLayerStyle)="onChangeStyle($event)"
              (onClickExternalProjectname)="onClickExternalProjectname($event)"
              (onHoverOrLeaveExternalProjectTitle)="onHoverOrLeaveExternalProjectTitle($event)"
              [layers]="layers['allProjects']"
              [showToggles]="showToggles"
              [showSubLayer]="true"
              [type]="'external_projects'"
            ></app-feature-layers-accordion>
          </mat-accordion>

          <mat-accordion *ngIf="hasModule('share_only')">
            <app-feature-layers-accordion
              (toggleOpenDataLayers)="toggleOpenDataLayers($event)"
              (onChangeLayerStyle)="onChangeStyle($event)"
              (onClickExternalProjectname)="onClickExternalProjectname($event)"
              (onHoverOrLeaveExternalProjectTitle)="onHoverOrLeaveExternalProjectTitle($event)"
              [layers]="layers['customerProjects']"
              [showToggles]="showToggles"
              [showSubLayer]="true"
              [type]="'internal_projects'"
            ></app-feature-layers-accordion>
          </mat-accordion>
        </div>
      </mat-card>

      <!-- open data  -->
      <mat-card data-cy="openlayers-sidebar-v2__card-6" class="p-10 mb-10" *ngIf="!contextPanel && !contextGraph">
        <div class="d-flex j-space-between">
          <h3 class="a-self-center layers-header-title">Open Data</h3>
          <span *ngIf="hasRole('Project Admin') && !isSharedSubproject()">
            <a
              data-cy="openlayers-sidebar-v2__a-self-center"
              class="a-self-center d-cursor-hand mr-10"
              (click)="addOpenDataLayers()"
              matTooltip="{{ 'maps.add_layer' | transloco }}"
              ><mat-icon class="uil uil-plus-circle"></mat-icon></a
          ></span>
        </div>
        <div
          *ngIf="is_loadOpenData"
          class="w-100 load-openlayers d-flex j-space-center"
        >
          <mat-spinner></mat-spinner>
        </div>
        <mat-accordion>
          <app-feature-layers-accordion
            *ngIf="!is_loadOpenData"
            (toggleOpenDataLayers)="toggleOpenDataLayers($event)"
            (onChangeLayerStyle)="onChangeStyle($event)"
            [layers]="layers['openData']"
            [type]="'openlayers'"
            [showToggles]="showToggles"
            [showSubLayer]="true"
            (loadOpenData)="loadOpenData()"
          ></app-feature-layers-accordion>
        </mat-accordion>
        <mat-divider class="z-99" *ngIf="!isSharedSubproject()"></mat-divider>
        <!-- Overpass Layer Data -->
        <div class="mbt-25" *ngIf="!contextPanel && !isSharedSubproject()">
          <div>
            <label class="pull-left openlayer-sidebar_label">{{
              "potential_stakeholder" | transloco
            }}</label>
            <mat-slide-toggle data-cy="openlayers-sidebar-v2__potential-stakeholder-toggle"
              *ngIf="!displayProgressSpinner"
              [disabled]="!showToggles"
              [(ngModel)]="potentialStakeholderToggle"
              class="pull-right openlayer-sidebar_slider-toggle"
              (change)="toggleOverpassLayer($event)"
            ></mat-slide-toggle>
            <span *ngIf="displayProgressSpinner" class="pull-right loader-span">
              <img
                class="pull-left group_svg spinner"
                src="/assets/png/spinner.png"
                alt="decisions"
              />
            </span>
          </div>
        </div>
      </mat-card>
      <!-- Geo JSON  -->
      <mat-card data-cy="openlayers-sidebar-v2__card-7"
        class="p-10 mb-10"
        *ngIf="!isSharedSubproject()"
      >
        <div class="d-flex j-space-between align-baseline">
          <h3 class="layers-header-title">
            Custom data
          </h3>
          <span>
            <a data-cy="openlayers-sidebar-v2__a-self-center-2"
              class="a-self-center d-cursor-hand mr-10"
              (click)="openGeoJsonModal()"
              matTooltip="{{ 'maps.add_layer' | transloco }}"
              >
                <span class="ts-14 mr-8">Toevoegen</span>
                <i class="uil uil-plus-circle ts-24"></i>
              </a>
            </span>
        </div>
        <div
          *ngIf="is_loadingGeoJsonData"
          class="w-100 load-openlayers d-flex j-space-center"
        >
          <mat-spinner></mat-spinner>
        </div>
        <ng-container *ngIf="!is_loadingGeoJsonData">
          <mat-accordion>
            <app-feature-layers-accordion
            (toggleOpenDataLayers)="toggleOpenDataLayers($event)"
            (onChangeLayerStyle)="onChangeStyle($event)"
            (loadCustomData)="initGeoJsonLayers()"
            [layers]="layers['geojson']"
            [showToggles]="showToggles"
            [showSubLayer]="true"
            [enableCustomDataDelete]="true"
            ></app-feature-layers-accordion>
          </mat-accordion>
        </ng-container>
      </mat-card>
      <!--integration Layers -->
      <mat-card data-cy="openlayers-sidebar-v2__card-8" class="p-10 mb-10" *ngIf="integrationEnable && !contextPanel && !contextGraph">
        <h3 class="layers-header-title">ArcGIS</h3>
        <div
          *ngIf="!loading"
          class="w-100 load-openlayers d-flex j-space-center"
        >
          <mat-spinner></mat-spinner>
        </div>
        <h3 *ngIf="!layers['arcgis'].length && loading" class="font-size-sta">
          <mat-icon class="d-text-middle">info</mat-icon
          ><span class="ml-5"
            >{{ 'maps.no_layer_found' | transloco}}</span
          >
        </h3>
        <div *ngIf="layers['arcgis'].length && loading">
          <mat-accordion>
            <app-feature-layers-accordion
              (toggleOpenDataLayers)="toggleOpenDataLayers($event)"
              (onChangeLayerStyle)="onChangeStyle($event)"
              [layers]="layers['arcgis']"
              [type]="'integrationconfigs'"
              [showToggles]="showToggles"
              [showSubLayer]="true"
            ></app-feature-layers-accordion>
          </mat-accordion>
        </div>
      </mat-card>
    </div>
    <!-- Side Tab -->
    <div class="sidebar-pane active" *ngIf="createItem">
      <h1 class="sidebar-header" (click)="sidebarClose()">
        {{ "settings.create_item" | transloco }}
        <span class="sidebar-close" #closeLayer><<</span>
      </h1>
      <ng-container *transloco="let t">
        <mat-card data-cy="openlayers-sidebar-v2__card-9" style="flex-direction: inherit !important; align-items: baseline !important;"
          [ngClass]="
            tool == 'stakeholders' || tool == 'stakeholders_polygons'
              ? 'active'
              : ''
          "
          *ngIf="hasPermission(Permission.StakeholdersCreate)"
        >
          <img
            style="bottom: 0px !important"
            class="pull-left openlayer-sidebar_svg"
            src="/assets/png/stakeholders.png"
            alt="Stakeholders"
          />
          <label class="pull-left openlayer-sidebar_label">{{
            t("stakeholders.labels") | titlecase
          }}</label>
          <span class="activity-options">
            <mat-icon data-cy="openlayers-sidebar-v2__set-tool"
              *ngIf="enableStakeholdersPolygons"
              [ngClass]="tool == 'stakeholders_polygons' ? 'active' : ''"
              (click)="setTool('stakeholders_polygons')"
              >crop_landscape</mat-icon
            >
            <mat-icon data-cy="openlayers-sidebar-v2__set-tool-2"
              [ngClass]="tool == 'stakeholders' ? 'active' : ''"
              (click)="setTool('stakeholders')"
            >
              radio_button_checked</mat-icon
            >
          </span>
        </mat-card>
        <mat-card data-cy="openlayers-sidebar-v2__card-10" style="flex-direction: inherit !important; align-items: baseline !important;"
          [ngClass]="tool == 'issues' ? 'active' : ''"
          (click)="setTool('issues')"
          *ngIf="hasPermission(Permission.IssuesCreate)"
        >
          <img   style="bottom: 0px !important"
            class="pull-left openlayer-sidebar_svg"
            src="/assets/png/issues.png"
            alt="Issues"
          />
          <label class="pull-left openlayer-sidebar_label">{{
            t("issues.labels") | titlecase
          }}</label>
        </mat-card>

        <mat-card data-cy="openlayers-sidebar-v2__card-11"  style="flex-direction: inherit !important; align-items: baseline !important;"
          [ngClass]="tool == 'complaints' ? 'active' : ''"
          (click)="setTool('complaints')"
          *ngIf="hasPermission(Permission.ComplaintsCreate)"
        >
          <img   style="bottom: 0px !important"
            class="pull-left openlayer-sidebar_svg"
            src="/assets/png/complaints.png"
            alt="Meldingen"
          />
          <label class="pull-left openlayer-sidebar_label">{{
            t("complaints.labels") | titlecase
          }}</label>
        </mat-card>

        <mat-card data-cy="openlayers-sidebar-v2__card-12"  style="flex-direction: inherit !important; align-items: baseline !important;"
          [ngClass]="tool == 'requirements' ? 'active' : ''"
          (click)="setTool('requirements')"
          *ngIf="hasPermission(Permission.DecisionsCreate)"
        >
          <img   style="bottom: 0px !important"
            class="pull-left openlayer-sidebar_svg"
            src="/assets/png/requirements.png"
            alt="klanteisen"
          />
          <label class="pull-left openlayer-sidebar_label">{{
            t("decisions.labels") | titlecase
          }}</label>
        </mat-card>

        <mat-card data-cy="openlayers-sidebar-v2__card-13"  style="flex-direction: inherit !important; align-items: baseline !important;"
          [ngClass]="
            tool == 'calendars' || tool == 'calendars_lines' ? 'active' : ''
          "
          *ngIf="hasPermission(Permission.ActivitiesCreate)"
        >
          <img   style="bottom: 0px !important"
            class="pull-left openlayer-sidebar_svg"
            src="/assets/png/calendars.png"
            alt="Activiteiten"
          />
          <label class="pull-left openlayer-sidebar_label">{{
            t("activities.labels") | titlecase
          }}</label>
          <span class="activity-options">
            <mat-icon data-cy="openlayers-sidebar-v2__set-tool-3"
              [ngClass]="tool == 'calendars_lines' ? 'active' : ''"
              (click)="setTool('calendars_lines')"
            >
              timeline</mat-icon
            >
            <mat-icon data-cy="openlayers-sidebar-v2__set-tool-4"
              [ngClass]="tool == 'calendars' ? 'active' : ''"
              (click)="setTool('calendars')"
            >
              radio_button_checked</mat-icon
            >
          </span>
        </mat-card>
      </ng-container>
    </div>
  </div>
</div>
